import React from 'react';
import PropTypes from 'prop-types';

class FreeToAnnual extends React.Component {
    render() {
        let mainCopy = (this.props.planAddOns || this.props.planTweets) ? `One year of Pro with your current add ons for $${this.props.planTotal}` : `One year of Pro for just $${this.props.promo.price}`;

        return (
            <div className="promo-content">
                {this.props.image ? (
                    this.props.image
                ) : null}
                <h1 className="main-copy">
                    {mainCopy}
                </h1>
                <div className="sub-copy">
                    Lock in our best available price our most popular plan. Limited time offer.
                </div>
                <button type="button" className="promo-action-button" onClick={this.props.onRedeemPromoClick}>
                    {'Get our best price'}
                </button>
                <div className="last-chance">
                    {`Get 12 months of our powerful Pro plan for just $${this.props.planTotal} today`}
                </div>
                <div className="coming-soon">
                    <h3>Hands-Free Social Media Publishing</h3>
                    <div className="feature-list">
                        {this.props.features.map((feature, i) => {
                            return (
                                <div key={`feature-${i}`} className="feature-detail">
                                    <div className="feature-image">
                                        <img src={feature.image}/>
                                    </div>
                                    <div className="feature-name">
                                        {feature.label}
                                    </div>
                                    <div className="feature-desc">
                                        {feature.description}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        )
    }
}

FreeToAnnual.displayName = "FreeToAnnual";

FreeToAnnual.propTypes = {
    image: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.object
    ]),
    promo: PropTypes.object,
    onRedeemPromoClick: PropTypes.func,
    features: PropTypes.array,
    planAddOns: PropTypes.number,
    planTweets: PropTypes.number,
    planTotal: PropTypes.number.isRequired
};

FreeToAnnual.defaultProps = {
    image: null,
    promo: null,
    onRedeemPromoClick: () => {},
    features: [],
    planAddOns: 0,
    planTweets: 0
};

export default FreeToAnnual;
